<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Abuse Filtered IPs</v-card-title>
      <v-card-subtitle>
        Source IPs automatically filtered due to detected abuse.
      </v-card-subtitle>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="sources"
        :search="search"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";

export default {
  mounted() {
    api
      .query("abuse_filtered")
      .then(
        (response) =>
          (this.sources = response.data.map((row) => ({
            ...row,
            id: `${row.source}_${row.created_at}`,
          })))
      )
      .catch((error) => (this.errors = [error]))
      .finally(() => (this.loading = false));
  },

  data: () => ({
    selected: [],
    headers: [
      { text: "Source", value: "source" },
      { text: "Created At", value: "created_at" },
    ],
    sources: [],
    errors: [],
    loading: true,
    search: "",
  }),
};
</script>
